<div class="d-flex justify-content-center align-items-center">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="card mt-2 mb-2">
          <div class="card-body p-5 g-3">
            <h4 class="d-inline-block" i18n>Reset password</h4>
            <p i18n>If we find an account associated with your email address, we'll reset your password and send you an
              email right away.</p>
            <form class="mb-3 g-3 row" [formGroup]="form">
              <div class="col-12">
                <label class="form-label" i18n>Email</label>
                <input class="form-control" required formControlName="email"
                  [class.is-invalid]="form.get('email')?.invalid && form.get('email')?.touched" autocomplete="email">
              </div>
              <div class="col-12">
                <button type="submit" class="btn btn-primary w-100" (click)="send()" [disabled]="!this.form.valid"
                  i18n>Reset password</button>
                <br><br>
                <button type="submit" class="btn btn-secondary w-100" (click)="router.navigate(['/signin'])" i18n>Back to
                  sign in</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>